export const MAX_DRAWER_WIDTH = 480;
